<template>
  <div class="pay_box">
    <template v-if="showPage">
      <section class="date_box">
        <section :class="['date_box_top', 'date_box_flex']">
          <section class="date_start">
            <p>合同开始</p>
            <p>{{ dateMess.applayStartDay | formatTime(6) }}</p>
          </section>
          <!-- <p :class="['date_item',item.isCurMonth?'cur_month':'',item.payStatus == '已缴'?'have_pay':'']" v-for="(item,index) in monthList" :key="item.month">
        <span>{{item.monthText}}</span>
        <span class="cur_month_t" v-if="item.isCurMonth">本月</span>
        <span class="have_paytext" v-if="item.payStatus == '已缴'">已缴</span>
        <span class="date_year" v-if="!item.isCurMonth && item.year != monthList[monthList.length-1].year">{{item.year}}</span>
      </p> -->
          <img
            v-if="dateMess.monthList.length > 12"
            class="icon_more"
            src="../../assets/images/icon_more.png"
          />
          <section class="date_start">
            <p>合同结束</p>
            <p>{{ dateMess.applayEndDay | formatTime(6) }}</p>
          </section>
        </section>
        <section class="record" @click="toPayRecord">
          <p>缴费记录</p>
          <img src="../../assets/images/icon_indicator_next.png" />
        </section>
      </section>
      <template v-if="dateMess.hasPay">
        <!-- 如果有待支付的订单 -->
        <template v-if="pendingBill">
          <ul class="pay_data pendingBill_data">
            <li class="pay_data_item">
              <span>充值起始时间</span>
              <p>{{ pendingBill.startDay }}</p>
            </li>
            <li class="pay_data_item">
              <span>充值结束时间</span>
              <p>{{ pendingBill.endDay }}</p>
            </li>
            <li class="pay_data_item">
              <span>月租费</span>
              <p>¥ {{ dateMess.feeStandard | priceFormat }}</p>
            </li>
            <li v-if="payMess.yearFeeStandard" class="pay_data_item">
              <span>年费</span>
              <p>¥ {{ payMess.yearFeeStandard | priceFormat }}</p>
            </li>
            <li class="pay_data_item">
              <span>需支付金额</span>
              <p class="price">¥ {{ pendingBill.amount | priceFormat }}</p>
            </li>
          </ul>
        </template>
        <template v-else>
          <!-- 日期选择box -->
          <section :class="$store.state.common.theme !=3 ?'chooseList' : 'chooseList chooseList_3'">
            <div class="chooseListItem">
              <p>缴费开始日期</p>
              <!--  @click="selectTime(1)" 开始日期不可修改  startDay-->
              <section class="select_date_item">
                <span class="span">{{ startDay }}</span>
              </section>
            </div>
            <div class="chooseListItem" @click="select()">
              <p>充值月数</p>
              <section class="select_date_item">
                <span
                  v-if="monthType == 2"
                  :class="[applyDay ? 'span' : 'span1']"
                  >{{ applyDay ? applyDay : "请选择充值月数" }}</span
                >
                <span
                  v-if="monthType == 1"
                  :class="[applyDay ? 'span' : 'span1']"
                  >{{ applyDay ? applyDay : "" }}</span
                >
                <img
                  v-if="monthType == 1"
                  class="chooseListItemimg"
                  src="../../assets/images/icon_indicator_next.png"
                />
              </section>
            </div>
            <div :class="$store.state.common.theme !=3 ?'chooseListItem':'chooseListItem chooseListItem_3'" @click="selectTime(2)">
              <p>缴费结束日期</p>
              <section class="select_date_item">
                <span class="span">{{ endDay }}</span>
                <img
                  v-if="monthType == 2"
                  class="chooseListItemimg"
                  src="../../assets/images/icon_indicator_next.png"
                />
              </section>
            </div>
          </section>
          <template v-if="showPayMessage">
            <section v-if="payMess.giveMsg" class="give_msg">
              <span>满赠</span>
              <p>{{ payMess.giveMsg }}</p>
            </section>
            <section v-for="(item, index) in records" :key="index">
              <!-- 提示 -->
              <section class="tips" v-if="item.diffDay">
                <img src="../../assets/images/parking/icon_hint.png" />
                <p>租赁期内非整月应缴费用按照当月实际天数折算</p>
              </section>
              <p v-if="!item.diffDay && index != 0" class="all_month">
                整月充值部分
              </p>
              <!-- 数据 -->
              <ul :class="$store.state.common.theme !=3 ?'pay_data' : 'pay_data pay_data_3'">
                <li class="pay_data_item">
                  <span>充值起始时间</span>
                  <p>{{ item.startDay | formatTime(9) }}</p>
                </li>
                <li class="pay_data_item">
                  <span>充值结束时间</span>
                  <p>{{ item.endDay | formatTime(9) }}</p>
                </li>
                <li  :class="!payMess.yearFeeStandard&&$store.state.common.theme ==3 ?'pay_data_item pay_data_item_3' :'pay_data_item'">
                  <span>月租费</span>
                  <p>¥ {{ item.feeStandard | priceFormat }}</p>
                </li>
                 <li v-if="payMess.yearFeeStandard"  :class="$store.state.common.theme !=3 ?'pay_data_item':'pay_data_item pay_data_item_3'">
                    <span>年费</span>
                    <p>¥ {{ payMess.yearFeeStandard | priceFormat }}</p>
                  </li>
                <li class="pay_data_item">
                  <span>需支付金额</span>
                  <p class="price">¥ {{ needPayPrice | priceFormat }}</p>
                </li>
              </ul>
            </section>
          </template>
        </template>
      </template>
      <!-- 全部缴费完成 -->
      <section class="all_pay" v-else>
        <img src="../../assets/images/icon_blank_praise.png" />
        <p>已全部缴清合同期内剩余月租费</p>
        <span>好棒！点个赞</span>
      </section>
      <section class="footer_h"></section>
      <!-- 返回上一份合同 -->
      <template v-if="!isCurContract">
        <section class="footer_xq"></section>
        <p
          :class="['back_contract', showPayMessage ? '' : 'msg_box_b']"
          @click="backContract"
        >
          返回上一份合同
        </p>
      </template>
      <!-- 您已续签，去缴续签合同 -->
      <template
        v-if="xqContractId && isCurContract && showPayMessage && !pendingBill"
      >
        <section class="footer_xq"></section>
        <section
          :class="['xq_textbox', showPayMessage ? '' : 'msg_box_b']"
          @click.stop="toXuqian"
        >
          <p>您已续签，去缴续签合同</p>
          <img src="../../assets/images/icon_indicator_next.png" />
        </section>
      </template>
      <common-footer
        v-if="xqContractId && isCurContract && !showPayMessage && !pendingBill"
        text="您已续签，去缴续签合同"
        :canClick="true"
        @btnClick="toXuqian"
      ></common-footer>
      <common-footer
        v-if="!pendingBill && showPayMessage"
        :text="`立即支付¥ ${needPayPrice}`"
        :canClick="canClick"
        @btnClick="btnClick"
      ></common-footer>
      <template v-if="pendingBill">
        <section class="footer_tips" v-if="waitPay"></section>
        <section class="wait_pay_tips" v-if="waitPay" @click="waitPay = false">
          <img
            class="tips_icon"
            src="../../assets/images/parking/icon_hint.png"
          />
          <p>您有未完成的缴费单</p>
          <img class="close_icon" src="../../assets/images/parking/close.png" />
        </section>
        <footer class="footer_box button">
          <span class="btn_primary btn_left" @click="cancelPay">取消支付</span>
          <span class="btn_default btn_right" @click="paySubmit">立即支付</span>
        </footer>
      </template>
      <yd-datetime
        style="display: none"
        ref="datetime"
        @input="dateChange"
        type="date"
        v-model="date"
        :startDate="rangeStartTime"
        :endDate="rangeEndTime"
      ></yd-datetime>
      <!-- <yd-datetime style="display:none;" ref="startDay" v-model="startDay" type="month"></yd-datetime>
  <yd-datetime style="display:none;" ref="endDay" v-model="endDay" type="month"></yd-datetime> -->
    </template>
    <!-- 有满减活动 -->
    <template
      v-if="dateMess.rechargeGiveMsg && !pendingBill && dateMess.hasPay"
    >
      <section class="msg_height"></section>
      <section
        :class="[
          'msg_box',
          showPayMessage ? '' : 'msg_box_b',
          xqContractId && showPayMessage ? 'msg_box_c' : '',
          xqContractId && !showPayMessage ? 'msg_box_d' : '',
        ]"
      >
        <section class="msg_box_m">
          <img src="../../assets/images/icon_park_notice.png" />
          <p>{{ dateMess.rechargeGiveMsg }}</p>
          <span @click="lookDetail">详情</span>
        </section>
      </section>
    </template>

    <mt-popup v-model="popupVisible" position="bottom" class="mint-popup">
      <mt-picker
        class="picker"
        :slots="pickList"
        @change="onValuesChange"
        :visible-item-count="5"
        :show-toolbar="true"
        ref="picker"
      >
        <div class="picker_wrap">
          <div class="picker_btn" @click="popupVisible = false">取消</div>
          <div class="picker_btn2" @click="handleConfirm">确认</div>
        </div>
      </mt-picker>
    </mt-popup>
  </div>
</template>


<script>
import CommonFooter from "../../components/footer";
import util from "../../utils/util";
import storage from "../../utils/storage";
import { loadParkHeaderById, removeRequestOrder } from "../../utils/api";
import { mapState } from "vuex";
import ping from "../../utils/pingpay.js";
import moment from "moment";
import wx from "weixin-js-sdk";
//import wx from 'jweixin-1.6.0'
let timer = null;
export default {
  name: "parkingPay",
  props: {},
  components: {
    CommonFooter,
  },
  filters: {},
  computed: {
    ...mapState({
      common: (state) => state.common,
    }),
    monthList() {
      let monthList = this.dateMess.monthList || [];
      let curMonth = new Date().getMonth() + 1;
      let curYear = new Date().getFullYear();
      monthList.forEach((item) => {
        item.monthText = util.formatTime(new Date(item.month), 15);
        item.isCurMonth =
          curMonth == util.formatTime(new Date(item.month), 17).month &&
          curYear == util.formatTime(new Date(item.month), 17).year;
        item.year = util.formatTime(new Date(item.month), 16);
      });
      return monthList.filter((item, index) => {
        return index < 12;
      });
    },
  },
  data() {
    return {
      canClick: true,
      waitPay: true,
      changeStartDate: false,
      showPage: false,
      dateMess: "",
      date: "",
      startDay: "2022/01/01", //开始月份
      endDay: "", //结束月份 '2050/12/31'
      applyDay: "", //租赁期
      canSelectApplyDay: true,
      isSupportPartialPayment:1,
      time: "",
      rangeStartTime: "", //开始可选时间
      userS: false,
      showPayMessage: "",
      feeStandard: "", //月租费
      records: [],
      needPayPrice: "",
      pendingBill: "", //待支付的订单数据
      amount: "", //应付价格
      giveCount: 0, //赠送月数
      canPay: true,
      payMess: "",
      xqContractId: "", //续签合同id
      isCurContract: true, //是否是当前合同
      rangeEndTime: "", //结束可选时间

      parkHeaderId: "",
      applyLogId:'',
      parkInfo: "",
      startDateConf: "",
      monthType: "",

      applyData: "",
      feeTypeId: "",
      feeTypeObj: "",
      applyEndDay_HT: "",
      applyMaxCount: "",
      //弹框选择

      Qishulist: [
        {
          flex: 1,
          values: [],
          className: "slot1",
          textAlign: "center",
        },
      ],
      pickType: "",
      popupVisible: false,
      pickList: [],
    };
  },
  created() {
    this.xqContractId = this.$route.query.xqContractId || "";
    this.parkHeaderId = this.$route.query.parkHeaderId || "";
    this.applyDataId = this.$route.query.id || "";
    this.getParkInfo();

      // var startDay = moment(1675094400000) //add(1, "day"); 1661875200000
      // startDay = util.formatTime(new Date(startDay), 4);
      // console.log("startDay in create ====" +startDay);
      // let applyEndDay = moment(1677513599000); //1664467199000
      // console.log("applyEndDay in create ====" +applyEndDay);
      // var applyDay = moment(applyEndDay)
      //           .add(1, "day")
      //           .diff(new Date(startDay.replace(/-/g, "/") + " 00:00:00"), "month",true).toFixed(4);
      // console.log("add(1, day) in create ====" +moment(applyEndDay)
      //           .add(1, "day"));
      // applyDay= parseFloat(applyDay) +0.1
      // console.log("this.applyDay float in create ====" +applyDay);
      // applyDay = parseInt(applyDay)
      // console.log("this.applyDay in create ====" +applyDay);
      // var a  =   moment(applyEndDay)
      //           .add(1, "day")
      //           .diff(new Date(startDay.replace(/-/g, "/") + " 00:00:00"), 'months',true).toFixed(4)
      // console.log("toFixed4 a   ====" +a);


      // var startDay1 = moment(1661875200000) //add(1, "day");
      // startDay1 = util.formatTime(new Date(startDay1), 4);
      // console.log("startDay1 in create ====" +startDay1);
      // let applyEndDay1 = moment(1664467199000); //
      // console.log("applyEndDay1 in create ====" +applyEndDay1);
      // var applyDay1 = moment(applyEndDay1)
      //           .add(1, "day")
      //           .diff(new Date(startDay1.replace(/-/g, "/") + " 00:00:00"), "month",true).toFixed(4);
      // console.log("add1(1, day) in create ====" +moment(applyEndDay1)
      //           .add(1, "day"));
      // applyDay1= parseFloat(applyDay1) +0.1
      // console.log("this.applyDay float in create ====" +applyDay1);
      // applyDay1 = parseInt(applyDay1)
      // console.log("this.applyDay1 in create ====" +applyDay1);
      // var a1  =   moment(applyEndDay1)
      //           .add(1, "day")
      //           .diff(new Date(startDay1.replace(/-/g, "/") + " 00:00:00"), 'months',true).toFixed(4)
      // console.log("toFixed4 a1   ====" +a1);


  },
  mounted() {},
  methods: {
    // 获取用户申请信息
    loadParkLot() {
      let params = {
        userId: this.common.userId,
        phone: this.common.userInfo.account || this.common.userInfo.phone,
        parkHeaderId: this.$route.query.parkHeaderId,
        url: "/parking/rstParkLot/loadParkLot",
      };
      //  console.log('loadParkLot' +JSON.stringify(params))
      loadParkHeaderById(params).then((res) => {
        console.log("loadParkLot" + JSON.stringify(res));
        if (res.res && res.res.code === 10000 && res.body && res.body.data) {
          this.applyData = res.body.data; // 根据 feeTypeId 匹配车场的收费类型
          // this.feeTypeId = this.applyData.feeTypeId;
          var feeTypeList = this.parkInfo.prkParkFeeBeanList;
          if( this.xqContractId && this.applyData.prkParkApplyLogBeans){  //只有续租获取 feeTypeId
                for(var i=0;i<this.applyData.prkParkApplyLogBeans.length;i++){
                   var obj = this.applyData.prkParkApplyLogBeans[i];
                      if(obj.id == this.xqContractId){
                            for (var j = 0; j < feeTypeList.length; j++) {
                                var item = feeTypeList[j];
                                if (item.id ==  obj.feeTypeId) {
                                  this.feeTypeObj = item;
                                  this.feeTypeId = item.id;
                                  break;
                                }
                            }
                            break
                      }
                }
          }else{ //不是续租根据订单的feeTypeId 获取对应的feeType类型

            for (var n = 0; n < feeTypeList.length; n++) {
                var nitem = feeTypeList[n];
                if (nitem.id == this.applyData.feeTypeId) {
                    this.feeTypeObj = nitem;
                    this.feeTypeId = nitem.id;
                    break;
                }
            }
          }


          // 获取当前项数据
          this.queryCurrentBill();
        }
      });
    },
    // /parking/parkLotApp/queryPrkParkLotById
    getParkInfo() {
      //获取车场信息
      let params = {
        id: Number(this.parkHeaderId),
        url: "/parking/rstParkHeader/loadParkHeaderById",
      };
      loadParkHeaderById(params).then((res) => {
        //  console.log('loadPrkParkHeader ==== '  +JSON.stringify( res) )
        if (res.res.code === 10000 && res.body.data) {
          this.parkInfo = res.body.data;
          this.startDateConf = res.body.data.startDateConf;
          this.monthType = res.body.data.monthType;
          this.isSupportPartialPayment = res.body.data.isSupportPartialPayment;
          this.loadParkLot();
        }
      });
    },

    datetime() {},
    lookDetail() {
      util.showModal(
        "",
        `${this.dateMess.rechargeGiveMsg}`,
        false,
        "我知道了",
        () => {}
      );
    },
    // 获取用户申请信息
    queryCurrentBill(applayLogId) {
      util.showLoading();
      let params = {
        id: Number(this.$route.query.id), //车位id
        applayLogId: applayLogId, //合同id
        url: "/parking/rstParkLot/queryCurrentBill",
      };
      loadParkHeaderById(params).then((res) => {
        this.showPage = true;
        this.userS = false;
        util.hideLoading();
        console.log("queryCurrentBill    " + JSON.stringify(res));
        if (res.res.code === 10000 && res.body && res.body.data) {
          this.dateMess = res.body.data.data;
          if (this.dateMess.startDay) {
            console.log("this.dateMess.startDay  ====" + this.dateMess.startDay);
            var bstartDay = util.beijingDay(this.dateMess.startDay) 
            this.startDay = util.formatTime(bstartDay,4); //选择的开始时间
            this.bstartDay = util.formatTime(bstartDay,4); //选择的开始时间
          }

          if (this.monthType == 2) {
            //let {year,month} = util.formatTime(new Date(res.body.data.data.applayStartDay),17);//合同开始时间
            this.rangeStartTime = util.formatTime(
              new Date(res.body.data.data.applayStartDay),
              19
            );
            this.rangeEndTime = util.formatTime(
              new Date(res.body.data.data.applayEndDay),
              19
            ); //合同结束时间
          }
          if (this.dateMess.pendingBill) {
            this.pendingBill = this.dateMess.pendingBill;
          } else {
            if (this.dateMess.hasPay) {
              //this.queryParkFee(util.formatTime(new Date(this.dateMess.startDay),9),util.formatTime(new Date(this.dateMess.endDay),9))
            }
          }
          let params1 = {
            parkLotId:Number(this.$route.query.id), //车位id
           // applyLogId:  this.applyLogId,      //
            url: "/parking/rstParkLot/queryEndDayByApplyLogId",
          };
          if (!this.isCurContract && this.xqContractId) {
              params1.applyLogId = this.xqContractId; //合同id
            }
          loadParkHeaderById(params1).then((res1) => {
            if (res1.body.data) {

              this.lastTime = res1.body.data;
               console.log("this.lastTime  ==== " + JSON.stringify(this.lastTime));
              var startDay = moment(this.lastTime) //add(1, "day");
              var bstartDay = util.beijingDay(startDay) 
              this.startDay = util.formatTime(bstartDay,4); //选择的开始时间
              // this.startDay = util.formatTime(new Date(startDay), 4);
              console.log("this.startDay ====" +this.startDay);
            } else {
              // this.startDay = moment(this.dateMess.startDay)
            }
            let applyEndDay = moment(this.dateMess.applayEndDay);

            this.applyEndDay_HT = applyEndDay ? applyEndDay : ""; //合同 截止日期
            // this.applyEndDay = applyEndDay //缴费 可选择结束日期
            this.endDay = util.formatTime(new Date(applyEndDay), 4);
            if (this.monthType == 1) {
               console.log("this.monthType == 1");
               console.log("applyEndDay ==== " +applyEndDay);
              // this.applyDay = moment(applyEndDay)
              //   .add(1, "day")
              //   .diff(new Date(this.startDay), "month");
              //    console.log("this.applyDay ====" +this.applyDay);

               var applyDay = moment(applyEndDay)
                .add(1, "day")
                .diff(new Date(this.startDay.replace(/-/g, "/") + " 00:00:00"), "month",true).toFixed(4);

                applyDay= parseFloat(applyDay) +0.1  //结束日期为2月27号的 计算结果会是 .9的数字缺少0.1 其他结果1.0 ，加0.1不影响转int的值
                console.log("applyDay ====" +applyDay);
                this.applyDay = parseInt(applyDay)
                console.log("this.applyDay ====" +this.applyDay);

              if (util.minus(this.applyDay, this.feeTypeObj.payMinCount) < 0) {
                console.log("in unminus");
                this.canSelectApplyDay = false;
              } else {
                this.canSelectApplyDay = true;


                  this.applyMaxCount =
                  util.minus(this.applyDay, this.feeTypeObj.applyMaxCount) < 0
                    ? this.applyDay
                    : this.feeTypeObj.applyMaxCount;

                console.log("feeTypeObj ==== " + JSON.stringify(this.feeTypeObj) );
                console.log('feeTypeId === ' +this.feeTypeId)
                console.log("payMinCount ==== " + this.feeTypeObj.payMinCount);
                console.log("applyMaxCount =====" + this.applyMaxCount);
                if (this.feeTypeObj.payMinCount && this.applyMaxCount) {
                  let list = [],
                    count = this.feeTypeObj.payMinCount;
                  while (count <= this.applyMaxCount) {
                    list.push(count);
                    count++;
                  }
                  this.Qishulist[0].values = list;
                } else {
                  this.Qishulist[0].values = [];
                }
              }
            } else {
              let endDay = moment(this.endDay).add(1, "day");
              let month = endDay.diff(moment(this.startDay), "month",true).toFixed(4);
              month=parseInt(month)
              this.applyDay =
                month +
                "月" +
                moment(endDay)
                  .subtract(month, "month")
                  .diff(moment(this.startDay), "day") +
                "天（" +
                endDay.diff(moment(this.startDay), "day") +
                "天）";
            }

            var start = util.formatTime(
              new Date(this.startDay.replace(/-/g, "/") + " 00:00:00"),
              9
            );
            var end = util.formatTime(
              new Date(this.endDay.replace(/-/g, "/") + " 23:59:59"),
              9
            );

             this.queryParkFee(start, end);
          });
        } else {
          util.showToast(res.res.msg);
        }
      });
    },
    // 获取支付数据
    queryParkFee(startDay, endDay) {
      var sDate= new Date(startDay);
      var eDate= new Date(endDay);
      var st =Number(sDate.getTime())
      var et =Number(eDate.getTime())
      if(st>et){ // 开始日期 大于结束日期 不请求数据
         this.showPayMessage = false;
         this.payMess ='';
         this.records=[];
         console.log('开始日期 大于结束日期')
         return
      }
      util.showLoading();
      let params = {
        id: Number(this.$route.query.id),
        // applayLogId: Number(this.$route.query.id),
        applyDay:this.applyDay,
        startDay: startDay,
        endDay: endDay,
        url: "/parking/rstParkLot/queryParkFee",
      };
      if (!this.isCurContract && this.xqContractId) {
        params.applayLogId = this.xqContractId; //合同id
      }
      loadParkHeaderById(params).then((res) => {
        // console.log('in loadParkHeaderById' )
        if (res.res.code === 10000) {
          util.hideLoading();
          this.userS = true;
          if (res.body && res.body.data && res.body.data.data) {
            this.payMess = res.body.data.data;
            // console.log('payMess ====' + JSON.stringify(this.payMess))
            this.records = this.payMess.records || [];
            if (this.records.length > 0) {
              this.showPayMessage = true;
            } else {
              this.showPayMessage = false;
            }
            // this.feeStandard = this.payMess.feeStandard;
            this.calculationAllamount(); //计算金额
          } else {
            this.showPayMessage = false;
            util.showToast(res.body.data.msg, 2000);
          }
        } else {
          util.showToast(res.res.msg);
        }
      });
    },
    commonComputed() {
      let endDay = moment(this.endDay).add(1, "day");
      let month = endDay.diff(moment(this.startDay), "month",true).toFixed(4);
      month =parseInt(month)
      this.applyDay =
        month +
        "月" +
        moment(endDay)
          .subtract(month, "month")
          .diff(moment(this.startDay), "day") +
        "天（" +
        endDay.diff(moment(this.startDay), "day") +
        "天）";
      var start = util.formatTime(
        new Date(this.startDay.replace(/-/g, "/") + " 00:00:00"),
        9
      );
      var end = util.formatTime(
        new Date(this.endDay.replace(/-/g, "/") + " 23:59:59"),
        9
      );
      this.queryParkFee(start, end);
    },
    nameInputFun(e) {
      this.$emit("inputChange", { val: e.data, type: "name" });
    },
    selectTime(val) {
      if (this.monthType == 1 || this.isSupportPartialPayment == 0) {
        //整月模式不可选择
        return;
      }
      this.timeT = val;
      this.userS = true;
      this.$refs.datetime.open();
    },
    dateChange(val) {
      console.log(val);
      if (!this.userS) {
        return false;
      }
      if (this.timeT == "1") {
        this.startDay = val;
        // // 判断,如果开始时间大于结束时间,重置结束时间
        // let startT = new Date((this.startDay+'-01').replace(/-/g,'/')+' 00:00:00').getTime()
        // let endT = new Date((this.endDay+'-01').replace(/-/g,'/')+' 00:00:00').getTime()
        // if(endT < startT){
        //   this.endDay = val;
        // }
      } else {
        this.endDay = val;
        // // 判断,如果开始时间大于结束时间,重置开始时间
        // let startT = new Date((this.startDay+'-01').replace(/-/g,'/')+' 00:00:00').getTime()
        // let endT = new Date((this.endDay+'-01').replace(/-/g,'/')+' 00:00:00').getTime()
        // if(endT < startT){
        //   this.startDay = val;
        // }
      }
      this.commonComputed();
    },
    select() {
      if (this.monthType == 1 && this.canSelectApplyDay && this.isSupportPartialPayment ==1) {
        //选择缴费租期
        this.popupVisible = true;
        this.pickList = this.Qishulist;
      }
    },
    onValuesChange(picker, values) {
      if (values[0] > values[1]) {
        picker.setSlotValue(1, values[0]);
      }
    },

    handleConfirm() {
      this.popupVisible = false;
      var valve = this.$refs.picker.getValues()[0];
      this.applyDay = valve;
      //计算结束日期
      this.calculationEndDate();
    },

    calculationEndDate() {
      if (!this.startDay || !this.applyDay) {
        return;
      }
      // if(this.startDateConf ==2){
      var endTime = moment(this.startDay)
        .add(this.applyDay, "month")
        .subtract(1, "day");
      this.endDay = util.formatTime(new Date(endTime), 4);
      var start = util.formatTime(
        new Date(this.startDay.replace(/-/g, "/") + " 00:00:00"),
        9
      );
      var end = util.formatTime(
        new Date(this.endDay.replace(/-/g, "/") + " 23:59:59"),
        9
      );
      this.queryParkFee(start, end);
      // }
    },
    //计算支付金额
    calculationAllamount() {
      var amount;
      if (this.monthType == 1) {
        // amount = util.multipliedBy(this.applyDay, this.payMess.feeStandard);
        if(this.payMess.yearFeeStandard &&this.payMess.yearFeeStandard>0){ //有年费按照 年费+剩余月数的月费
          var yearS = parseInt(this.applyDay/12)
          var monthS = this.applyDay%12
          // console.log('this.payMess  === ' + JSON.stringify(this.payMess))
          amount = util.multipliedBy(yearS,this.payMess.yearFeeStandard)+util.multipliedBy(monthS,this.payMess.feeStandard)
        }else{ //没有年费 按照月费计算
          amount = util.multipliedBy(this.applyDay, this.payMess.feeStandard);
        }
       // console.log('amount  === ' +amount)
        this.payMess.amount = amount;
        this.payMess.allAmount = amount;
        this.amount = this.payMess.amount;
        this.needPayPrice = util.priceFormat(this.payMess.allAmount);
      } else {
        var month = moment(this.endDay)
          .add(1, "day")
          .diff(moment(this.startDay), "month",true).toFixed(4);
        month =parseInt(month);
        var day = moment(this.endDay)
          .add(1, "day")
          .subtract(month, "month")
          .diff(moment(this.startDay), "day");
        var dayPay = util.div(
          util.multipliedBy(12, this.payMess.feeStandard, 10),
          365,
          10
        );
        // this.payMess.feeStandard*12/365
        // month* this.payMess.feeStandard + day*dayPay

        amount = util.plus(
          util.multipliedBy(month, this.payMess.feeStandard),
          util.multipliedBy(day, dayPay),
          2
        );
        console.log(month + "   " + day + "  " + dayPay + "   " + amount);
        this.payMess.amount = amount;
        this.payMess.allAmount = amount;
        this.amount = this.payMess.amount;
        this.needPayPrice = util.priceFormat(this.payMess.allAmount);
      }
    },

    // 支付
    paySubmit() {
      this.goPayCenter(this.pendingBill.payOrderNo);
    },
    // 取消订单
    cancelPay() {
      util.showModal("", "确定要取消支付吗?", true, "确定", () => {
        removeRequestOrder({ requestNo: this.pendingBill.orderNo }).then(
          (res) => {
            if (res.res.code === 10000) {
              this.showPayMessage = false;
              this.pendingBill = "";
              util.showToast("已取消");
              this.userS = false;
              if (this.isCurContract) {
                this.queryCurrentBill();
              } else {
                this.queryCurrentBill(this.xqContractId);
              }
            } else {
              util.showToast(res.res.msg);
            }
          }
        );
      });
    },
    goPayCenter(orderNo) {
      let that = this;
      if (!this.canPay) {
        return;
      }
      this.canPay = false;
      let params = {
        orderNo: orderNo,
        repairNo: "", // "报修单号",
        bussinessType: "7", //会议室1,活动2,租赁账单3,物业报修4,保洁服务5,送水服务6,7停车
        feeCode: "",
        // payType: '5', // "支付类型 0微信，1支付宝, 4万生活, 5,ping++"
        channel: "wx_pub", // 渠道名
      };
      ping(
        params,
        "",
        (res) => {
          storage.setS("isNeedFresh", true);
          util.showLoading("支付确认中,请稍后...");
          // 定时查询,如果没有待支付订单数据,停止定时器

          this.$router.replace('/parkingPaySuccess?id='+this.$route.query.id+'&parkHeaderId='+this.$route.query.parkHeaderId)
          timer = setInterval(() => {
            let params = {
              id: Number(this.$route.query.id), //车位id
              // applayLogId: "", //合同id
              url: "/parking/rstParkLot/queryCurrentBill",
            };
            if (!that.isCurContract) {
              params.applyLogId = this.xqContractId;
            }
            loadParkHeaderById(params).then((res) => {
              if (res.res.code === 10000 && res.body && res.body.data) {
                if (!res.body.data.data.pendingBill) {
                  this.dateMess = res.body.data.data;
                  this.pendingBill = "";
                  this.showPayMessage = false;
                  clearInterval(timer);
                  util.hideLoading();
                  this.userS = false;
                  if (that.isCurContract) {
                    that.queryCurrentBill();
                  } else {
                    that.queryCurrentBill(that.xqContractId);
                  }
                }
              }
            });
          }, 2000);
        },
        () => {
          that.userS = false;
          if (that.isCurContract) {
            that.queryCurrentBill();
          } else {
            that.queryCurrentBill(that.xqContractId);
          }
        },
        () => {
          that.userS = false;
          if (that.isCurContract) {
            that.queryCurrentBill();
          } else {
            that.queryCurrentBill(that.xqContractId);
          }
        },
        () => {
          // 订单状态已变更,取消订单
          removeRequestOrder({ requestNo: this.pendingBill.orderNo }).then(
            (res) => {
              if (res.res.code === 10000) {
                this.showPayMessage = false;
                this.pendingBill = "";
                this.queryCurrentBill();
              } else {
                util.showToast(res.res.msg);
              }
            }
          );
        }
      );
      setTimeout(() => {
        this.canPay = true;
      }, 1000);
    },
    toPayRecord() {
      this.$router.push(`/parkingPayRecord?id=${this.$route.query.id}`);
    },
    btnClick() {
      if (this.monthType != 1) {
        let applyDay = Number(this.applyDay.split("天（")[1].split("天）")[0]);
        if (Number(this.feeTypeObj.payMinCount) > applyDay) {
          util.showToast(
            "该计费标准最小支付" +
              this.feeTypeObj.payMinCount +
              "日，请重新选择租赁期"
          );
          return;
        } else if (applyDay > Number(this.feeTypeObj.applyMaxCount)) {
          util.showToast(
            "该计费标准最大起租" +
              this.feeTypeObj.applyMaxCount +
              "日，请重新选择租赁期"
          );
          return;
        }
      }
      //控制输入

      this.canClick = false;
      util.showLoading();
      var startDay = util.beijingDay(this.records[0].startDay)
      var endDay = util.beijingDay(this.records[this.records.length - 1].endDay)
      let params = {
        parkHeaderId: this.$route.query.parkHeaderId, //车场id
        subProjectId: this.common.marketInfo.id,
        parkLotId: this.$route.query.id, //车位id
        // applyLogId:this.$route.query.id,//车位id
        numberType: 2, //1、企业付费车位；2、个人月租；
        amount: this.payMess.allAmount, //账单金额
        payAmount: this.payMess.allAmount, //支付金额
        applyDay: this.applyDay,
        plateNo: "", //车牌号
        openId: this.common.openId,
        userId: this.common.userId,
        userName:
          this.common.userTenantInfo.userName || this.common.userInfo.userName,
        phone: this.common.userInfo.account || this.common.userInfo.phone,
        payCharge: 0, //手续费
        receivableMoney: 0, //实际到账金额
        monthCount: 0,
        giveCount: this.giveCount, //赠送月数
        startDay: util.formatTime(startDay, 9),
        endDay: util.formatTime(endDay,9),
        url: "/parking/rstParkBill/parkMonthlyBill",
      };
      console.log("params ==== " + JSON.stringify(params));
      loadParkHeaderById(params).then((res) => {
        util.hideLoading();
        if (res.res.code === 10000 && res.body && res.body.data) {
          this.goPayCenter(res.body.data.orderNo);
        } else {
          util.showToast(res.res.msg);
        }
        this.canClick = true;
      });
    },
    toXuqian() {
      this.isCurContract = false;
      this.queryCurrentBill(this.xqContractId);
    },
    backContract() {
      this.isCurContract = true;
      this.showPayMessage = false;
      this.queryCurrentBill();
    },
  },
  destroyed() {
    clearTimeout(timer);
  },
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
.pay_box {
  overflow: hidden;
}
.date_box {
  background: #eee url("../../assets/images/parking_bg.png") left center
    no-repeat;
  background-size: 100% 100%;
  height: 300px;
  width: 100%;
  .date_box_top {
    padding: 68px 28px 60px;
    height: 96px;
    .flex();
    flex-wrap: nowrap;
    align-items: center;
    overflow: scroll;
    -webkit-overflow-scrolling: touch;
    .date_start {
      height: 96px;
      .flex(column);
      align-items: flex-start;
      justify-content: center;
      padding-right: 28px;
      p {
        font-size: 26px;
        color: rgba(102, 102, 102, 1);
        line-height: 36px;
      }
    }
    .date_item {
      width: 96px;
      height: 96px;
      flex-shrink: 0;
      border-radius: 100%;
      .flex(column);
      align-items: center;
      justify-content: center;
      margin-right: 40px;
      background: #e2e2e2;
      position: relative;
      span {
        font-size: 32px;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        line-height: 44px;
        &.date_year {
          position: absolute;
          top: -48px;
          left: 50%;
          transform: translate(-50%);
          font-size: 26px;
          line-height: 36px;
          color: #666;
          font-weight: normal;
        }
      }
      .have_paytext {
        position: absolute;
        top: 100px;
        left: 50%;
        transform: translate(-50%);
        color: #16bc84;
        font-size: 24px;
      }
    }
    .icon_more {
      width: 36px;
      height: 36px;
      margin-right: 20px;
      margin-left: -20px;
    }
    .cur_month {
      background: #1740da;
      span {
        color: #fff;
        &.cur_month_t {
          font-size: 20px;
          color: #fff;
          line-height: 28px;
        }
      }
    }
    .have_pay {
      background: #16bc84;
      span {
        color: #fff;
        &.cur_month {
          font-size: 20px;
          color: #fff;
          line-height: 28px;
        }
      }
    }
  }
  .date_box_flex {
    width: 100%;
    .flex();
    justify-content: center;
  }
  .record {
    .flex();
    justify-content: flex-end;
    height: 40px;
    align-items: center;
    padding-right: 20px;
    p {
      font-size: 28px;
      color: rgba(51, 51, 51, 1);
      line-height: 40px;
      margin-right: 4px;
    }
    img {
      width: 32px;
      height: 32px;
    }
  }
}
.select_box {
  padding: 40px 20px;
  .flex();
  align-items: center;
  .select_box_date {
    .flex(column);
    justify-content: space-between;
    align-items: center;
    flex: 1;
    p {
      font-size: 28px;
      color: rgba(102, 102, 102, 1);
      line-height: 40px;
      margin-bottom: 14px;
    }
    .select_date_item {
      position: relative;
      width: 100%;
      height: 100px;
      .border();
      box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.06);
      border-radius: 8px;
      text-align: center;
      img {
        position: absolute;
        width: 32px;
        height: 32px;
        right: 20px;
        top: 34px;
      }
      .span {
        font-size: 32px;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        line-height: 100px;
      }
    }
  }
  .select_center {
    height: 100px;
    line-height: 100px;
    font-size: 32px;
    color: rgba(51, 51, 51, 1);
    margin: 0 16px;
    margin-top: 54px;
    width: 20px;
    position: relative;
    &:after {
      position: absolute;
      content: "";
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 20px;
      height: 4px;
      background: #666;
      border-radius: 2px;
    }
  }
}
.chooseList {
  margin: 20px 20px 28px;
  background: rgba(248, 248, 248, 1);
  border-radius: 8px;
  padding: 28px 28px 0;
  .flex();
  flex-direction: column;
  .chooseListItem {
    width: 100%;
    height: 80px;
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    p {
      font-size: 28px;
      color: rgba(102, 102, 102, 1);
      line-height: 40px;
    }
    .select_date_item {
      flex-direction: row;
      .span {
        font-size: 28px;
        color: rgba(51, 51, 51, 1);
        line-height: 40px;
      }
      .span1 {
        font-size: 28px;
        color: #999999;
        line-height: 40px;
      }
      .chooseListItemimg {
        width: 32px;
        height: 32px;
      }
    }
  }

  .chooseListItem_3{
    border-bottom: 1px solid rgba(0, 0, 0, 0.3);
  }
}
.chooseList_3{
  background: #fff;
}
.tips {
  padding: 8px 20px 20px;
  height: 36px;
  align-items: center;
  .flex();
  img {
    width: 28px;
    height: 28px;
    margin-right: 14px;
  }
  p {
    font-size: 26px;
    color: rgba(253, 152, 56, 1);
    line-height: 36px;
  }
}
.all_month {
  height: 36px;
  font-size: 26px;
  color: rgba(153, 153, 153, 1);
  line-height: 36px;
  margin-bottom: 20px;
  margin-left: 28px;
}
.pay_data {
  margin: 0 20px 28px;
  background: rgba(248, 248, 248, 1);
  border-radius: 8px;
  padding: 28px 28px 0;
  overflow: hidden;
  .pay_data_item {
    .flex();
    justify-content: space-between;
    margin-bottom: 28px;
    span {
      font-size: 28px;
      color: rgba(102, 102, 102, 1);
      line-height: 40px;
    }
    p {
      font-size: 28px;
      color: rgba(51, 51, 51, 1);
      line-height: 40px;
      &.price {
        color: #fc3f56;
        font-weight: bold;
      }
    }
  }
  .pay_data_item_3{
    border-bottom: 1px solid rgba(0, 0, 0, 0.3);
  }
}
.pay_data_3{
  background: #fff;
}
.pendingBill_data {
  margin-top: 40px;
}
.all_pay {
  .flex(column);
  justify-content: center;
  align-items: center;
  margin: 200px auto 300px;
  width: 100%;
  img {
    width: 100px;
    height: 100px;
    margin-bottom: 28px;
  }
  p {
    font-size: 36px;
    color: rgba(51, 51, 51, 1);
    line-height: 50px;
    margin-bottom: 20px;
  }
  span {
    font-size: 28px;
    color: rgba(153, 153, 153, 1);
    line-height: 40px;
  }
}
.footer_h {
  height: 120px;
}
.msg_height {
  height: 108px;
}
.footer_tips {
  height: 88px;
}
.wait_pay_tips {
  position: fixed;
  bottom: 108px;
  left: 0;
  right: 0;
  background: #feeedf;
  height: 88px;
  .flex();
  box-sizing: border-box;
  padding: 0 28px;
  align-items: center;
  .tips_icon {
    width: 28px;
    height: 28px;
    margin-right: 14px;
  }
  p {
    font-size: 26px;
    color: rgba(142, 127, 113, 1);
  }
  .close_icon {
    position: absolute;
    top: 0;
    right: 0;
    width: 44px;
    height: 44px;
    padding: 22px 10px;
  }
}
.footer_box {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 108px;
  background: #fff;
  .flex();
  align-items: center;
  padding: 0 28px;
  box-sizing: border-box;
  span {
    flex: 1;
    height: 68px;
    line-height: 68px;
    text-align: center;
    font-size: 28px;
    color: #fff;
    border-radius: 4px;
    box-sizing: border-box;
  }
  .btn_left {
    margin-right: 15px;
    .border(rgba(150,170,240,1));
    background: rgba(243, 245, 253, 1);
    color: @color17;
  }
  .btn_right {
    margin-left: 15px;
    background: @color17;
  }
}
.give_msg {
  font-size: 26px;
  color: rgba(252, 63, 86, 1);
  line-height: 36px;
  margin-bottom: 20px;
  padding: 0 28px;
  width: 100%;
  box-sizing: border-box;
  .flex();
  span {
    flex-shrink: 0;
    padding: 0 6px;
    height: 36px;
    box-sizing: border-box;
    margin-right: 8px;
    .border(#fd9faa);
    border-radius: 4px;
  }
  p {
    flex: 1;
    word-break: break-all;
  }
}
.msg_box {
  position: fixed;
  bottom: 108px;
  left: 0;
  right: 0;
  box-sizing: border-box;
  background: #fff;
  padding: 20px;
  .msg_box_m {
    height: 68px;
    .flex();
    align-items: center;
    border-radius: 34px;
    background: #f0f5fc;
  }
  img {
    width: 32px;
    height: 32px;
    margin-right: 14px;
    margin-left: 20px;
  }
  p {
    font-size: 24px;
    color: rgba(102, 102, 102, 1);
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    line-height: 44px;
  }
  span {
    font-size: 24px;
    color: rgba(23, 64, 218, 1);
    padding: 0 20px 0 40px;
    line-height: 44px;
  }
}
.footer_xq {
  height: 76px;
}
.back_contract {
  height: 76px;
  line-height: 76px;
  text-align: center;
  background: #fff;
  position: fixed;
  bottom: 108px;
  left: 0;
  right: 0;
  color: @color17;
  font-size: 28px;
  box-sizing: border-box;
  box-shadow: 0 -4px 12px 0 rgba(0, 0, 0, 0.06);
}
.xq_textbox {
  height: 76px;
  line-height: 76px;
  text-align: center;
  background: #fff;
  position: fixed;
  bottom: 108px;
  left: 0;
  right: 0;
  color: @color17;
  font-size: 28px;
  .flex();
  align-items: center;
  justify-content: center;
  img {
    width: 32px;
    height: 32px;
    margin-left: 8px;
  }
}
.msg_box_b {
  bottom: 0;
}
.msg_box_c {
  bottom: 186px;
}
.msg_box_d {
  bottom: 76px;
}
</style>
